import { Application } from "@hotwired/stimulus";
import RailsNestedForm from "@stimulus-components/rails-nested-form";

const application = Application.start();
application.register("nested-form", RailsNestedForm);

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };

const controllers = import.meta.glob(
  "./../components/**/controller.js",
  { eager: true },
);

for (let path in controllers) {
  let module = controllers[path];
  let name = path
    .match(/components\/(.+)\/controller\.js$/)[1]
    .replaceAll("_", "-")
    .replaceAll("/", "--");
  application.register(name, module.default);
}

const fragmentControllers = import.meta.glob(
  "./../../views/controllers/**/controller.js",
  { eager: true },
);

for (let path in fragmentControllers) {
  let module = fragmentControllers[path];
  let name = path
    .match(/controllers\/(.+)\/controller\.js$/)[1]
    .replaceAll("_", "-")
    .replaceAll("/", "--");
  application.register(name, module.default);
}

const oldfragmentControllers = import.meta.glob(
  "./../../views/fragments/**/controller.js",
  { eager: true },
);

for (let path in oldfragmentControllers) {
  let module = oldfragmentControllers[path];
  let name = path
    .match(/fragments\/(.+)\/controller\.js$/)[1]
    .replaceAll("_", "-")
    .replaceAll("/", "--");
  application.register(name, module.default);
}

const toRemovecontrollers = import.meta.glob(
  "./../../views/components/**/controller.js",
  { eager: true },
);

for (let path in toRemovecontrollers) {
  let module = toRemovecontrollers[path];
  let name = path
    .match(/views\/components\/(.+)\/controller\.js$/)[1]
    .replaceAll("_", "-")
    .replaceAll("/", "--");
  application.register(name, module.default);
}
